<template>
  <div class="title-bar">
    <div class="top-content">
      <div class="left-content">
        <div class="main-text">X-Brick Tool</div>
        <!-- <div class="small-text">Operation Terminal Alpha</div> -->
      </div>
      <!-- <div class="right-content">ART | XKool</div> -->
      <div class="right-logo">
        <a-space size="middle">
          <a-tooltip placement="bottom" overlayClassName="nav-tips">
            <template slot="title">
              <div class="nav-tips-text">使用说明<br />Useful tips</div>
            </template>
            <a-button
              shape="circle"
              icon="bulb"
              class="nav-bar-button"
              size="small"
              @click="openHelpfulDocument"
            />
          </a-tooltip>
          <router-link to="/"
            ><img
              src="../assets/images/xkool_gray.png"
              alt="XKOOL LOGO"
              width="60px"
            />
          </router-link>
        </a-space>
      </div>
    </div>
    <div class="bottom-content">
      <div class="navbar-bottom-line"></div>
    </div>
  </div>
</template>

<script>
export default {
  watch: {},
  name: "Navbar",
  components: {},
  props: {
    msg: String,
  },
  methods: {
    openHelpfulDocument() {
      window.open("https://www.yuque.com/lipeipei-7yor3/elkugx/rao70s");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.title-bar {
  width: 100%;
  height: 39px;
  display: flex;
  flex-direction: column;
  background: #ffffff;
}
.top-content {
  width: 100%;
  height: 39px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.left-content {
  display: flex;
  margin-left: 40px;
  align-items: baseline;
}
.main-text {
  font-size: 14pt;
  font-weight: bold;
}
.small-text {
  font-size: 8pt;
  margin-left: 10px;
  color: #5227a3;
}
.right-content {
  font-size: 14pt;
  font-weight: bold;
  margin-right: 40px;
}
.right-logo {
  font-size: 14pt;
  font-weight: bold;
  margin-right: 40px;
}
.navbar-bottom-line {
  width: 100%;
  height: 1px;
  background: #5227a3;
}

.nav-tips-text {
  text-align: center;
  font-size: 12px;
}

.nav-bar-button {
  color: #8c8c8c;
  border-color: #d9d9d9;
}
</style>
